import { Component, Inject, LOCALE_ID } from '@angular/core';
import { NgForm } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QuoteService } from '../../../quote/services/quote.service';
import { FileService } from '../../services/file.service';
import { AbstractBiditComponent } from '../abstract.bidit.component';
import { DealerDocument } from '../../models/dealer.document.interface';
import { RolePermission } from '../../models/role.permission.enum';

export interface PrintOptionsDialogData {
  quoteId: number,
  quote_ContractNotes: string,
  changeOrderId: number,
  showPricing: boolean,
  showSquareFootage: boolean,
  hideLineItemNotes: boolean,
  locale: string,
  showPrintAttachments: boolean,
  showTaxes: boolean,
  fillColor: string,
  groupAreas: boolean
}

@Component({
  selector: 'app-print-options-dialog',
  templateUrl: './print.options.dialog.html',
  styleUrls: ['./print.options.dialog.scss']
})
export class PrintOptionsDialog extends AbstractBiditComponent {

  showSquareFootage: boolean = false;
  showPricing: boolean = false;
  showTaxes: boolean = false;
  groupAreas: boolean = false;
  showLinePricing: boolean = false;
  hideLineItemNotes: boolean = false;

  locale: string = 'en';

  showPrintAttachments = false;
  showDocuments: boolean = false;
  documentsLoaded: boolean = false;
  dealerDocuments: DealerDocument[] = [];
  selectedDocuments: DealerDocument[] = [];
  documentBlobs: Blob[] = [];


  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    private fileService: FileService, private quoteService: QuoteService,
    public dialogRef: MatDialogRef<PrintOptionsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(deviceDetectorService);

    this.locale = locale;
    this.showLinePricing = QuoteService.hasPermission(RolePermission.ShowLineItemPricing);
  }

  printQuote(): void {
    this.isRequesting = true;

    let printOptionsData = {} as PrintOptionsDialogData;
    printOptionsData.quoteId = this.data.quote_ID;
    printOptionsData.quote_ContractNotes = this.data.quote_ContractNotes;
    printOptionsData.changeOrderId = this.data.changeOrder_ID;
    printOptionsData.showPricing = this.showPricing;
    printOptionsData.showSquareFootage = this.showSquareFootage;
    printOptionsData.hideLineItemNotes = this.hideLineItemNotes;
    printOptionsData.locale = this.locale;
    printOptionsData.showTaxes = this.showTaxes;
    printOptionsData.fillColor = this.data.fillColor;
    printOptionsData.groupAreas = this.groupAreas;

    this.selectedDocuments.forEach(dd => {
      this.quoteService.getDocumentAttachment(dd.dealerDocument_ID)
        .subscribe({
          next: (result) => {
            this.documentBlobs.push(result);
          },
          error: (error: string) => this.onError(error)
        });
    })

    this.quoteService.printQuoteContract(printOptionsData)
      .subscribe({
        next: (x) => {
          this.documentBlobs.unshift(x);
          this.fileService.downloadMergedFile(this.documentBlobs, 'QuoteContract.pdf');
          //this.isRequesting = false;
          this.dialogRef.close(this.data);
        },
        error: (error: string) => this.onError(error),
        complete: () => {
          this.isRequesting = false;
          return;
        }
      });
  }

  showQuoteDocuments() {
    this.showDocuments = true;
  }

  documentSelectionUpdated(documentsSelected: DealerDocument[]) {
    this.selectedDocuments = documentsSelected;
  }

  loadDocuments(loadedDocuments: DealerDocument[]) {
    this.dealerDocuments = loadedDocuments;
    this.showPrintAttachments = this.data.showPrintAttachments && loadedDocuments.length > 0;
    this.documentsLoaded = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
